<template>
  <div class="product-details-content-register-submodule-customization">
    <h5 class="text-semibold mb-1">Capa horizontal</h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          id="imagem-horizontal"
          v-model="form.header"
          title="Capa horizontal"
          isImage
          backgroundColor="bg-1"
          dimensions="1440x280"
        />
      </div>
      <div class="col d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-cover-desktop.svg" />
      </div>
    </div>
    <h5 class="text-semibold pt-7">Capa versão mobile</h5>
    <div class="row pb-6">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.cover_mobile"
          id="image-mobile-cover"
          title="Cartaz vertical"
          isImage
          backgroundColor="bg-1"
          dimensions="560x740"
        />
      </div>
      <div class="col d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-cover-mobile.svg" />
      </div>
    </div>
    <h5 class="text-semibold pt-7">Cartaz vertical</h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          id="imagem-vertical"
          v-model="form.picture"
          title="Cartaz vertical"
          isImage
          backgroundColor="bg-1"
          dimensions="560x800"
        />
      </div>
      <div class="col d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-placeholder-vertical.svg" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-register-submodule-customization {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
